module.exports = __webpack_public_path__ + "static/media/cardiogram.d996e1a6.svg";